/**
 * Configuración centralizada de la API
 * Detecta automáticamente el host para permitir acceso desde otros equipos
 */

// Función que calcula dinámicamente la URL EN RUNTIME
// NO depende de VITE_API_URL - detecta automáticamente el entorno
export const getApiUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  // 1. RAILWAY: Detectar por hostname *.railway.app
  const isRailway = hostname.endsWith('.railway.app');
  if (isRailway) {
    return 'https://smarthub-backend-production.up.railway.app';
  }

  // 2. LOCALHOST: Desarrollo local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8010';
  }

  // 3. DOCKER INTERNO: IP interna de Docker (172.x.x.x)
  if (hostname.startsWith('172.')) {
    return 'http://backend:8010';
  }

  // 4. RED LOCAL: IPs privadas (192.168.x.x, 10.x.x.x)
  // Útil para acceder desde otros dispositivos en la misma red
  return `${protocol}//${hostname}:8010`;
};

// WWW (public website) URL
export const getWwwUrl = () => {
  const hostname = window.location.hostname;
  if (hostname.endsWith('.railway.app')) return 'https://www.unie.edu.mx';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:3000';
  return 'https://www.unie.edu.mx';
};

// SmartTutor Microservice URL (port 8020)
export const getSmartTutorApiUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  if (hostname.endsWith('.railway.app')) {
    return 'https://smarthub-tutor-production.up.railway.app';
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8020';
  }
  if (hostname.startsWith('172.')) {
    return 'http://smarttutor:8020';
  }
  return `${protocol}//${hostname}:8020`;
};

// getSmartketingApiUrl removed in Sprint 6 — smarthub-marketing retired

// SmartPay Microservice URL (port 8040)
export const getSmartPayApiUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  if (hostname.endsWith('.railway.app')) {
    return 'https://smarthub-pay-production.up.railway.app';
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8040';
  }
  if (hostname.startsWith('172.')) {
    return 'http://smartpay:8040';
  }
  return `${protocol}//${hostname}:8040`;
};

/**
 * Returns true when the app is running on localhost (development).
 * Useful for disabling features that require external connectivity
 * (e.g. WhatsApp webhooks, channel testing).
 */
export const isLocalhost = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
};

// CRÍTICO: NO exportar como constante porque se calcula en build-time
// y window.location no existe en build-time, causando que devuelva HTTP
// export const API_URL = getApiUrl(); // ← REMOVIDO

// OBLIGATORIO: Siempre llamar a getApiUrl() en runtime
export const API_URL = null; // Deprecado - usar getApiUrl()
export const getDynamicApiUrl = getApiUrl;

// API configurada dinámicamente

// NOTA: El interceptor global de axios fue ELIMINADO porque apiClient
// ya construye URLs completas. El interceptor causaba problemas de
// minificación en Railway que resultaban en URLs HTTP en lugar de HTTPS.

export default API_URL;